import { Control, FieldPath, useController, RefCallBack } from 'react-hook-form';

interface OptionType<ValueType> {
    label: string;
    value: ValueType;
}

interface SelectControllerProps<ValueType, TFieldValues> {
    options: OptionType<ValueType>[];
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    render: (args: {
        field: {
            onChange: (newValue: OptionType<ValueType>) => void;
            onBlur: () => void;
            value: OptionType<ValueType>;
            name: string;
            ref: RefCallBack;
            options: OptionType<ValueType>[];
        };
    }) => React.ReactElement;
}

const SelectController = <ValueType, TFieldValues>({
    options,
    name,
    control,
    render,
}: SelectControllerProps<ValueType, TFieldValues>) => {
    const { field } = useController({
        control,
        name,
    });

    const getOptionOrDefault = (input: ValueType) =>
        options.find(({ value }) => value === input) ?? options[0];

    return render({
        field: {
            options,
            onChange: newValue => {
                field.onChange(newValue.value);
            },
            onBlur: field.onBlur,
            name: field.name,
            ref: field.ref,
            value: getOptionOrDefault(field.value as ValueType),
        },
    });
};

export default SelectController;
